import { AnyConceptStatusesByCid, ConceptStatusValueType, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ConceptStatusUpdate,
	DiagnosisReviewConcept,
	getConceptStatusValue,
	RDiagnosisReviewItem,
	ResultingDiagnosisConcept,
} from "@fusion-advantage/formlib"
import { FormRootState, FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { loadInitialDiagnosisReview, setResultingDiagnosis } from "../../redux/diagnosisReviewSlice"
import { RSecondaryCode } from "@fusion-advantage/backcompat"

export class DiagnosisReviewModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rParseModels = z.array(RDiagnosisReviewItem).safeParse(valueForCid(DiagnosisReviewConcept.cid))
		if(!rParseModels.success) {
			return err(serializeFusionError('DiagnosisReviewModelReduxPersister parseModels', rParseModels.error))
		}
		const rParseRdx = z.array(RSecondaryCode).safeParse(valueForCid(ResultingDiagnosisConcept.cid))
		if(!rParseRdx.success) {
			return err(serializeFusionError('DiagnosisReviewModelReduxPersister parseRdx', rParseRdx.error))
		}
		dispatch(loadInitialDiagnosisReview(rParseModels.data))
		dispatch(setResultingDiagnosis(rParseRdx.data))
		return ok()
	}
	shouldSave(prevState: FormRootState, nextState: FormRootState) {
		return prevState.diagnosisReview.models !== nextState.diagnosisReview.models
	}
	createStatusUpdates(nextState: FormRootState): ConceptStatusUpdate[] {
		return [{
			cid: DiagnosisReviewConcept.cid,
			value: nextState.diagnosisReview.models,
			// must be .Chosen to be picked up by formDraftMiddleware
			// for auto draft save
			valueType: ConceptStatusValueType.Chosen,
		}]
	}
}
